<template>
<b-row>
    <b-col cols="12">
      
      <b-btn class="return-btn" variant="outline-primary" @click.stop="returnhome">Return</b-btn>

      <b-jumbotron id="event">
        <template slot="header">
          <font class="event-title" size=8pt>{{event.title}}</font>
        </template>
        
        <template slot="lead">
        <font size="3" color="grey">
        Author: {{event.author}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Position: {{event.position}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Date Posted: {{event.date_posted}}
        </font><br><br>
          
          
        <div class="event-wrap">
Event Date: {{event.event_date}}
Time: {{event.start_time}} - {{event.end_time}}
Location: {{event.location}}
Discipline: {{event.discipline}}
Competition: {{event.competition}}
        <br>
{{event.description}}
        </div>
        </template>
        
        <b-btn class="edit-btn" variant="success" @click.stop="editevent(key)">Edit</b-btn>
        <b-btn class="delete-btn" variant="danger" @click.stop="deleteevent(key)">Delete</b-btn>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'ShowEvent',
  data () {
    return {
      key: '',
      event: {},
      scrolled: false
    }
  },
  created () {
    const ref = firebase.firestore().collection('events').doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.key = doc.id;
        this.event = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    editevent (id) {
      router.push({
        name: 'EditEvent',
        params: { id: id }
      })
    },
    deleteevent (id) {
      firebase.firestore().collection('events').doc(id).delete().then(() => {
        router.push({
          name: 'Dashboard'
        })
      }).catch((error) => {
        alert("Error removing event: ", error);
      });
    },
    returnhome (){
      router.push({
        name: "Dashboard"
      })
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
    text-align: center;
  }
  .event-title {
      font-variant: small-caps;
  }
  .edit-btn {
    margin-right: 20px;
    width: 70px;
  }
  .delete-btn {
    
    width: 70px;
  }
  .event-wrap {
  width: 50%;
  margin: 0 auto;
  white-space: pre-wrap;
}
.return-btn {
  margin-bottom: 20px;
}
</style>